module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "p9"
  }, [_c('span', {
    staticClass: "t7"
  }, [_vm._v("N")]), _c('span', {
    staticClass: "t8"
  }, [_vm._v("OVELS")]), _c('span', {
    staticClass: "t7"
  }), _c('span', {
    staticClass: "t8"
  }, [_vm._v("BY")])]), _vm._v(" "), _c('p', {
    staticClass: "p0"
  }, [_c('span', {
    staticClass: "t10"
  }, [_vm._v("J")]), _c('span', {
    staticClass: "t7"
  }, [_vm._v("OHN")]), _c('span', {
    staticClass: "t10"
  }, [_vm._v(" S")]), _c('span', {
    staticClass: "t7"
  }, [_vm._v("IMPSON")])]), _vm._v(" "), _c('p', {
    staticClass: "p10"
  }, [_c('span', {
    staticClass: "t7"
  }, [_vm._v("Alex and Clayton")])]), _vm._v(" "), _c('p', {
    staticClass: "p0"
  }, [_c('span', {
    staticClass: "t7"
  }, [_vm._v("Badges: An Anthology")])]), _vm._v(" "), _c('p', {
    staticClass: "p0"
  }, [_c('span', {
    staticClass: "t7"
  }, [_vm._v("Def Con One")])]), _vm._v(" "), _c('p', {
    staticClass: "p0"
  }, [_c('span', {
    staticClass: "t7"
  }, [_vm._v("Irish Winter")])]), _vm._v(" "), _c('p', {
    staticClass: "p11"
  }, [_c('span', {
    staticClass: "t7"
  }, [_vm._v("Jack and Dave")])]), _vm._v(" "), _c('p', {
    staticClass: "p0"
  }, [_c('span', {
    staticClass: "t7"
  }, [_vm._v("C")]), _c('span', {
    staticClass: "t8"
  }, [_vm._v("ONDOR")]), _c('span', {
    staticClass: "t7"
  }, [_vm._v(" O")]), _c('span', {
    staticClass: "t8"
  }, [_vm._v("NE")])]), _vm._v(" "), _c('p', {
    staticClass: "p0"
  }, [_c('span', {
    staticClass: "t7"
  }, [_vm._v("Condor One")])]), _vm._v(" "), _c('p', {
    staticClass: "p0"
  }, [_c('span', {
    staticClass: "t7"
  }, [_vm._v("Talons of the Condor")])]), _vm._v(" "), _c('p', {
    staticClass: "p0"
  }, [_c('span', {
    staticClass: "t7"
  }, [_vm._v("Condor and Falcon")])]), _vm._v(" "), _c('p', {
    staticClass: "p0"
  }, [_c('span', {
    staticClass: "t7"
  }, [_vm._v("Out of the Gilded Cage")])]), _vm._v(" "), _c('p', {
    staticClass: "p11"
  }, [_c('span', {
    staticClass: "t7"
  }, [_vm._v("Condor and the Crown")])]), _vm._v(" "), _c('p', {
    staticClass: "p0"
  }, [_c('span', {
    staticClass: "t7"
  }, [_vm._v("M")]), _c('span', {
    staticClass: "t8"
  }, [_vm._v("URDER")]), _c('span', {
    staticClass: "t7"
  }, [_vm._v(" M")]), _c('span', {
    staticClass: "t8"
  }, [_vm._v("OST")]), _c('span', {
    staticClass: "t7"
  }, [_vm._v(" G")]), _c('span', {
    staticClass: "t8"
  }, [_vm._v("AY")])]), _vm._v(" "), _c('p', {
    staticClass: "p0"
  }, [_c('span', {
    staticClass: "t7"
  }, [_vm._v("Murder Most Gay")])]), _vm._v(" "), _c('p', {
    staticClass: "p0"
  }, [_c('span', {
    staticClass: "t7"
  }, [_vm._v("Task Force")])]), _vm._v(" "), _c('p', {
    staticClass: "p0"
  }, [_c('span', {
    staticClass: "t7"
  }, [_vm._v("The Rent Boy Murders")])]), _vm._v(" "), _c('p', {
    staticClass: "p0"
  }, [_c('span', {
    staticClass: "t7"
  }, [_vm._v("Murder on a Queen")])]), _vm._v(" "), _c('p', {
    staticClass: "p10"
  }, [_c('span', {
    staticClass: "t9"
  }, [_vm._v("E")]), _c('span', {
    staticClass: "t11"
  }, [_vm._v("B")]), _c('span', {
    staticClass: "t9"
  }, [_vm._v("OOKS")]), _c('span', {
    staticClass: "t11"
  }), _c('span', {
    staticClass: "t9"
  }, [_vm._v("BY")]), _c('span', {
    staticClass: "t11"
  })]), _vm._v(" "), _c('p', {
    staticClass: "p11"
  }, [_c('span', {
    staticClass: "t11"
  }, [_vm._v("J")]), _c('span', {
    staticClass: "t9"
  }, [_vm._v("OHN")]), _c('span', {
    staticClass: "t11"
  }, [_vm._v(" S")]), _c('span', {
    staticClass: "t9"
  }, [_vm._v("IMPSON")])]), _vm._v(" "), _c('p', {
    staticClass: "p0"
  }, [_c('span', {
    staticClass: "t7"
  }, [_vm._v("The Barracks Affair")])]), _vm._v(" "), _c('p', {
    staticClass: "p0"
  }, [_c('span', {
    staticClass: "t7"
  }, [_vm._v("The Beach House")])]), _vm._v(" "), _c('p', {
    staticClass: "p0"
  }, [_c('span', {
    staticClass: "t7"
  }, [_vm._v("Carpathian Intrigue")])]), _vm._v(" "), _c('p', {
    staticClass: "p0"
  }, [_c('span', {
    staticClass: "t7"
  }, [_vm._v("Fairy Tale")])]), _vm._v(" "), _c('p', {
    staticClass: "p0"
  }, [_c('span', {
    staticClass: "t7"
  }, [_vm._v("Four Grooms and a Queen")])]), _vm._v(" "), _c('p', {
    staticClass: "p0"
  }, [_c('span', {
    staticClass: "t7"
  }, [_vm._v("The Ghosts of Stanton Hall")])]), _vm._v(" "), _c('p', {
    staticClass: "p0"
  }, [_c('span', {
    staticClass: "t7"
  }, [_vm._v("Hard Streets")])]), _vm._v(" "), _c('p', {
    staticClass: "p0"
  }, [_c('span', {
    staticClass: "t7"
  }, [_vm._v("Naval Maneuvers")])]), _vm._v(" "), _c('p', {
    staticClass: "p0"
  }, [_c('span', {
    staticClass: "t7"
  }, [_vm._v("Pirate Booty")])]), _vm._v(" "), _c('p', {
    staticClass: "p0"
  }, [_c('span', {
    staticClass: "t7"
  }, [_vm._v("School of Discipline")])]), _vm._v(" "), _c('p', {
    staticClass: "p0"
  }, [_c('span', {
    staticClass: "t7"
  }, [_vm._v("Wolf’s Head Inn")])]), _vm._v(" "), _c('p', {
    staticClass: "p12"
  }, [_c('span', {
    staticClass: "t7"
  }, [_vm._v("All available from")])]), _vm._v(" "), _c('p', {
    staticClass: "p0"
  }, [_c('span', {
    staticClass: "t11"
  }, [_vm._v("D")]), _c('span', {
    staticClass: "t9"
  }, [_vm._v("REAMSPINNER")]), _c('span', {
    staticClass: "t11"
  }, [_vm._v(" P")]), _c('span', {
    staticClass: "t9"
  }, [_vm._v("RESS")])]), _vm._v(" "), _c('p', {
    staticClass: "p0"
  }, [_c('span', {
    staticClass: "t7"
  }, [_vm._v("http://www.dreamspinnerpress.com")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1ad4a8b1","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/003.vue
// module id = 60
// module chunks = 0